import { render, staticRenderFns } from "./EmergencyHives.vue?vue&type=template&id=5901b789&scoped=true&"
import script from "./EmergencyHives.vue?vue&type=script&lang=js&"
export * from "./EmergencyHives.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyHives.vue?vue&type=style&index=0&id=5901b789&prod&lang=scss&"
import style1 from "./EmergencyHives.vue?vue&type=style&index=1&id=5901b789&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901b789",
  null
  
)

export default component.exports